export default __webpack_public_path__ + "e03ebed45bc5f52f22360f9361cb996c.png";